export const data = {
	heading: 'Credit.Club',
	mission: 'Наша миссия — делать кредиты доступными, развивая технологии для всех участников рынка',
	about:
		'Мы создаём технологичные кредитные продукты совместно с другими финансовыми компаниями. Объединяем экспертизу и технологии, чтобы клиенты получали удобные и эффективные решения.',
}
